// --------------
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// IE11 Polyfills
import { default as functionName } from 'function.name-polyfill'; // eslint-disable-line no-unused-vars
import { default as stringStartsWith } from 'string.prototype.startswith'; // eslint-disable-line no-unused-vars

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@awesomecomponents/mux/core/typography/assets/fonts/fonts.css';
import { initExternalConfig } from './utils/configuration';

const findIndex = require('array.prototype.findindex');
const find = require('array.prototype.find');
findIndex.shim();
find.shim();
initExternalConfig();

ReactDOM.render(<App name="Formhero App" />, document.getElementById('root'));
